import { api } from './client';

/* Admin & auth endpoints return raw entities or plain message strings. */

export async function signup(payload) {
  const res = await api.post('/auth/signup', payload);
  return res.data;
}

export async function listUsers() {
  const res = await api.get('/admin/users');
  return res.data || [];
}

export async function listActiveUsers() {
  const res = await api.get('/admin/users/active');
  return res.data || [];
}

export async function getUser(id) {
  const res = await api.get(`/admin/users/${id}`);
  return res.data;
}

export async function updateUser(id, payload) {
  const res = await api.put(`/admin/users/${id}`, payload);
  return res.data;
}

export async function deactivateUser(id) {
  const res = await api.delete(`/admin/users/${id}`);
  return res.data;
}

export async function listAdminDepartments(userId) {
  const res = await api.get(`/admin/users/${userId}/departments`);
  return res.data || [];
}

export async function assignDepartmentToAdmin(userId, departmentId) {
  const res = await api.post(`/admin/users/${userId}/departments`, { departmentId });
  return res.data;
}

export async function revokeDepartmentFromAdmin(userId, departmentId) {
  const res = await api.delete(`/admin/users/${userId}/departments/${departmentId}`);
  return res.data;
}
